import * as React from "react";
import Alert from "./ui/Alert";

export default function ParseResults({ result, error }) {
  if (error) {
    return (
      <section className="card !rounded-none !border-x-0 !p-3">
        <Alert title="Parse failed" variant="error">
          {error}
        </Alert>
      </section>
    );
  }

  if (!result) return null;

  const isFolder = result.mode === "folder";

  return (
    <section className="card space-y-2 !rounded-none !border-x-0 !p-3">
      <Alert
        title={isFolder ? "Folder import successful" : "Parse complete"}
        variant={result.errorCount > 0 ? "warning" : "success"}
      >
        {isFolder && result.fileCount != null ? `${result.fileCount} file(s) processed — ` : ""}
        {result.parsedCount} row(s) into {result.columnCount} column(s)
        {result.errorCount > 0 ? ` with ${result.errorCount} error(s).` : "."}
      </Alert>

      <div className="grid grid-cols-3 gap-1.5">
        <div className="rounded-lg bg-slate-50 px-2 py-1.5 ring-1 ring-slate-200/70">
          <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">
            {isFolder ? "Files OK" : "Rows"}
          </p>
          <p className="text-sm font-semibold text-slate-950">{result.parsedCount}</p>
        </div>
        <div className="rounded-lg bg-slate-50 px-2 py-1.5 ring-1 ring-slate-200/70">
          <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Columns</p>
          <p className="text-sm font-semibold text-slate-950">{result.columnCount}</p>
        </div>
        <div className="rounded-lg bg-slate-50 px-2 py-1.5 ring-1 ring-slate-200/70">
          <p className="text-[10px] font-medium uppercase tracking-wide text-slate-400">Errors</p>
          <p className="text-sm font-semibold text-slate-950">{result.errorCount}</p>
        </div>
      </div>

      {result.errors?.length > 0 && (
        <div className="subcard !p-2">
          <p className="mb-1 text-xs font-semibold text-slate-800">{isFolder ? "File errors" : "Row errors"}</p>
          <ul className="max-h-24 space-y-1 overflow-y-auto text-[11px] text-slate-600">
            {result.errors.map((item, index) => (
              <li
                key={item.label || item.fileName || item.rowIndex || index}
                className="rounded-md border border-red-100 bg-red-50/50 px-2 py-1"
              >
                <span className="font-medium text-red-800">
                  {item.label || item.fileName || `Row ${item.rowIndex + 1}`}:
                </span>{" "}
                {item.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
